import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.min.css';

import configureStore, { history } from "./redux/store";
import * as Sentry from '@sentry/browser';
import 'airbnb-js-shims';

Sentry.init({ dsn: "https://bf64d0c3cac34eebacd3e3942c96a80e@sentry.io/1727952" });
const store = configureStore();

ReactDOM.render(<Provider store={store}>
  <ConnectedRouter history={history}>
    <App store={store} />
  </ConnectedRouter>
</Provider>,
  document.getElementById('root'));

serviceWorker.unregister();
